import {Site} from '@/plugins/api'

// Site (tenant) đang chạy, lấy từ GET /site-config theo Origin: c1 -> Khối 1, c2 -> Khối 6, c3 -> Khối 10.
// Không persist: cấu hình do admin sửa trong DB, nạp lại mỗi lần mở trang.
// Origin chưa đăng ký (vd chạy bằng localhost) -> config null, các màn hình giữ hành vi cũ.
const LEVELS = {'1': 'primary', '6': 'secondary', '10': 'high'}

export default {
  namespaced: true,
  state: {
    config: null,
    loaded: false
  },
  actions: {
    async fetchSiteConfig({commit}) {
      try {
        commit('setConfig', await Site.config())
      } catch (e) {
        commit('setConfig', null)
      }
    }
  },
  mutations: {
    setConfig(state, config) {
      state.config = config || null
      state.loaded = true
    }
  },
  getters: {
    isUserSite: state => Boolean(state.config && state.config.type === 'user'),
    // Khối của site phụ huynh: '1' | '6' | '10', hoặc null nếu chưa xác định
    siteGrade: (state, getters) => {
      if (!getters.isUserSite) return null
      const grades = (state.config.settings && state.config.settings.grades) || []
      return grades.length ? String(grades[0]) : null
    },
    // Khối theo cấp học (primary/secondary/high) như enrollmentGrade, exam.grade
    siteLevel: (state, getters) => LEVELS[getters.siteGrade] || null,
    // Khối của luồng hồ sơ (primary/secondary/high): theo site (c1 -> Khối 1, c2 -> Khối 6, c3 -> Khối 10).
    // Origin chưa đăng ký (localhost) mới dùng khối lúc đăng ký tài khoản như trước.
    documentLevel: (state, getters, rootState) =>
      getters.siteLevel || (rootState.auth.user && rootState.auth.user.enrollmentGrade) || null
  }
}
